<template>
  <div id="bLogoCont">
    <transition name="logo-switch">
      <img class="bLogo" src="../../assets/b-icon-header-dark.svg" alt="B Logo" v-show="darkModeOn" />
    </transition>
    <transition name="logo-switch">
      <img class="bLogo" src="../../assets/b-icon-header-light.svg" alt="B Logo" v-show="darkModeOff" />
    </transition>
  </div>
</template>

<script>
  
export default {
  name: 'BLogoHeader',
  
  data() {
    return {
      
    }
  },
  
  computed: {
    darkModeOn() {
      return this.$store.state.settings.darkModeOn;
    },
    darkModeOff() {
      return !this.$store.state.settings.darkModeOn;
    }
  }
}

</script>

<style scoped>
  .bLogo {
    width: 32px;
    height: 33px; 
    position: absolute;
  }
  
  #bLogoCont {
    width: 32px;
    height: 33px;
    transform: translateY(1px);
    border: solid blue 0px;
    position: relative;
  }
  
  .logo-switch-enter-active {
    transition: all 500ms ease-out;
    opacity: 1;
  }

  .logo-switch-leave-active {
    transition: all 500ms ease-in;
    opacity: 0;
  }

  .logo-switch-enter, .header-switch-leave-to {
    opacity: 0;
  }
  
</style>
